import { Auth0Provider } from './auth0';
import { MockedAuthProvider } from './mockedAuth';

export const AuthProvider =
  process.env.REACT_APP_DISABLE_AUTH === 'true' ? MockedAuthProvider : Auth0Provider;
